"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const constant_1 = require("./constant");
let entityCounter = 0;
class Entity {
    constructor() {
        this.ai = () => ({ no: 0, targetId: 0 });
        this.entityId = ++entityCounter;
        this.properties = new Map();
        this.teamId = -1;
        this.tags = [];
        this.hp = 1;
        this.no = 0;
        this.name = '<Unknown>';
        this.dead = false;
        this.lv = 40;
        this.skills = [];
        this.rank = 'X';
        this.battleData = new Map();
        this.turnData = new Map();
        this.summonToken = false;
        this.waitInput = false;
        lodash_1.forEach(lodash_1.values(constant_1.BattleProperties), key => {
            this.setProperty(key, 0);
        });
        this.setProperty(constant_1.BattleProperties.MAX_HP, 1);
    }
    /**
     * 获得实体存储的附加数据，详见setBattleData
     * @param {string} key
     * @return {string|null} 返回数据，对应key不存在返回null
     */
    getBattleData(key) {
        return this.battleData.get(key) || null;
    }
    /**
     * 设置实体存储的附加数据，主要用于式神记录一些临时数据
     * @param key
     * @param value
     */
    setData(key, value) {
        if (value === null) {
            return this.battleData.delete(key);
        }
        this.battleData.set(key, value);
        return true;
    }
    /**
     * 获得实体存储的附加数据，该数据表会在每次正式回合开始时被清空，详见setTurnData
     * @param {string} key
     * @return {string|null} 返回数据，对应key不存在返回null
     */
    getTurnData(key) {
        return this.turnData.get(key) || null;
    }
    /**
     * 设置实体存储的附加数据，该数据表会在每次正式回合开始时被清空，主要用于式神记录一些临时数据
     * 比如记录本回合内是否有人死亡，比如犬神记录本回合有没有人砍了队友
     * @param key
     * @param value
     */
    setTurnData(key, value) {
        if (value === null) {
            return this.turnData.delete(key);
        }
        this.turnData.set(key, value);
        return true;
    }
    addSkill(skill) {
        this.skills.push(skill);
    }
    addTags(tag) {
        if (!this.hasTag(tag)) {
            this.tags.push(tag);
        }
    }
    removeTags(tag) {
        const index = this.tags.indexOf(tag);
        if (index !== -1) {
            this.tags.splice(index, 1);
        }
    }
    hasTag(tag) {
        return this.tags.includes(tag);
    }
    getProperty(name) {
        const origin = this.properties.get(name);
        if (lodash_1.isNil(origin))
            return 0;
        return origin;
    }
    hasProperty(name) {
        return this.properties.has(name);
    }
    setProperty(name, value = 0) {
        this.properties.set(name, value);
    }
    setTeam(teamId) {
        this.teamId = teamId;
    }
    setName(name) {
        this.name = name;
    }
    // 同步hp到原始最大生命值
    syncHp() {
        this.hp = this.getProperty(constant_1.BattleProperties.MAX_HP);
    }
    getSkill(no) {
        const ret = this.skills.find(s => s.no === no);
        if (!ret)
            throw Error('Cannot found skill, no = ' + no);
        return ret;
    }
}
exports.default = Entity;
Entity.no = 0;
